import {
  groupLifeProposalsService,
  type GroupLifeProposalStepName,
} from '@/services/proposals/group-life';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

export function useSaveGroupLifeProposalStep(policyId?: string) {
  const queryClient = useQueryClient();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  /** `error` traz a mensagem da Api (ex.: 403 de corretora inativa). */
  const save = async (
    step: GroupLifeProposalStepName,
    payload: Record<string, unknown>,
  ): Promise<{ ok: boolean; error?: string }> => {
    setError(null);
    if (!policyId) {
      return { ok: true };
    }
    setSaving(true);
    try {
      const result = await groupLifeProposalsService.saveStep({
        policyId,
        step,
        payload,
      });
      if (!result.success) {
        setError(result.error ?? 'Falha ao salvar no InsureMO');
        return { ok: false, error: result.error };
      }
      await queryClient.invalidateQueries({
        queryKey: ['group-life-proposal', policyId],
      });
      return { ok: true };
    } finally {
      setSaving(false);
    }
  };

  return { save, saving, error };
}
